import i18n from "@/i18n";

// 所有回答类型选项
export const answerTypeOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.allAnswer"),
        value: "all",
    },
    {
        label: i18n.t("zhiji.robotLog.noAnswer"),
        value: "noAnswer",
    },
    {
        label: i18n.t("zhiji.robotLog.answered"),
        value: "hasAnswer",
    }
];

// 提问类型选项
export const questionTypeOptions = () => [
    {
        label: i18n.t("zhiji.robotLog.selectType"),
        value: "all"
    },
    {
        label: i18n.t("zhiji.robotLog.byUesr"),
        value: "user"
    },
    {
        label: i18n.t("zhiji.robotLog.byScene"),
        value: "scenes"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestion"),
        value: "stand"
    },
    {
        label: i18n.t("zhiji.robotLog.byQuestionId"),
        value: "questionId"
    },
    {
        label: i18n.t("zhiji.robotLog.byChatId"),
        value: "chatId"
    },
];

// 场景表格配置
export const channelTableConfig = () => {
    return {
        columns: [
            {
                colId: "setName",
                header: i18n.t("zhiji.likedisplay.setName"),
                type: "Text",
            },
            {
                colId: "feedbackNum",
                header: i18n.t("zhiji.likedisplay.feedbackNum"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "feedbackRatePrint",
                header: i18n.t("zhiji.likedisplay.feedbackRatePrint"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "likeRatePrint",
                header: i18n.t("zhiji.likedisplay.likeRatePrint"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "evaluateIrrelevant",
                header: i18n.t("zhiji.likedisplay.evaluateIrrelevant"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "evaluateDissatisfactionNum",
                header: i18n.t("zhiji.likedisplay.evaluateDissatisfactionNum"),
                type: "Text",
                width: 110,
                sortable: "custom",
            },
            {
                colId: "evaluateUnresolved",
                header: i18n.t("zhiji.likedisplay.evaluateUnresolved"),
                type: "Text",
                width: 110,
                sortable: "custom",
            },
            {
                colId: "evaluateCustomized",
                header: i18n.t("zhiji.likedisplay.evaluateCustomized"),
                type: "Text",
                sortable: "custom",
            },
        ],
        pageLength: 10
    }
}

// fqa表格配置
export const faqTableConfig = () => {
    return {
        columns: [
            {
                colId: "question",
                header: i18n.t("zhiji.likedisplay.question"),
                type: "Text",
            },
            {
                colId: "feedbackNum",
                header: i18n.t("zhiji.likedisplay.feedbackNum"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "feedbackRatePrint",
                header: i18n.t("zhiji.likedisplay.feedbackRatePrint"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "likeRatePrint",
                header: i18n.t("zhiji.likedisplay.likeRatePrint"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "evaluateIrrelevant",
                header: i18n.t("zhiji.likedisplay.evaluateIrrelevant"),
                type: "Text",
                sortable: "custom",
            },
            {
                colId: "evaluateDissatisfactionNum",
                header: i18n.t("zhiji.likedisplay.evaluateDissatisfactionNum"),
                type: "Text",
                width: 110,
                sortable: "custom",
            },
            {
                colId: "evaluateUnresolved",
                header: i18n.t("zhiji.likedisplay.evaluateUnresolved"),
                type: "Text",
                width: 110,
                sortable: "custom",
            },
            {
                colId: "evaluateCustomized",
                header: i18n.t("zhiji.likedisplay.evaluateCustomized"),
                type: "Text",
                sortable: "custom",
            },
        ],
        pageLength: 10
    }
}

export const praiseTableConfig = () => {
    return {
        columns: [
            {
                colId: "createdAt",
                header: i18n.t("zhiji.likedisplay.messageTime"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "questionType",
                header: i18n.t("zhiji.likedisplay.questionType"),
                type: "Text",
                width: "10%"
            },
            {
                colId: "question",
                header: i18n.t("zhiji.likedisplay.questionContent"),
                type: "Text",
                width: "22%"
            },
            {
                colId: "channel",
                header: i18n.t("zhiji.likedisplay.channel"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "enQuestion",
                header: i18n.t("zhiji.likedisplay.enQuestion"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "enQuestionId",
                header: i18n.t("zhiji.likedisplay.enQuestionId"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "transEnQuestion",
                header: i18n.t("zhiji.likedisplay.transEnQuestion"),
                type: "Text",
                width: "12%"
            },
            {
                colId: "reason",
                header: i18n.t("zhiji.likedisplay.reason"),
                type: "Text",
                width: "12%"
            },
        ],
        isHideFooter: true,
        pageLength: 10
    }
}
